
import { ChannelsListContainer } from "./ChannelsListContainer";

type ChannelsListProps = {
  groupId: string;
  userRole: string;
};

export function ChannelsList({ groupId, userRole }: ChannelsListProps) {
  return <ChannelsListContainer groupId={groupId} userRole={userRole} />;
}
